import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { pathFor } from "@/i18n/routes";

export const L = ({ to, search = "", ...props }) => {
  const { lang } = useLang();
  return <Link to={`${pathFor(lang, to)}${search}`} {...props} />;
};
